import Template from './template';
import Document from './document';
import GridData from './grid_data';

import DocumentHelper from '../helpers/document_helper';

// TODO (LV): Refatorar o construtor para a estrutura similar a do form_store_item.
export default class DocumentStoreItem {
	_inputId;
	_inputName;
	_inputProps;
	_template;
	_document;
	_selected;
	_selectedDuplicateDocument;
	_duplicateDocuments;
	_divergentDocumentVersion;
	_flashMessage;
	_waitingForAction;
	_documentLoaded;
	_submitData;
	_gridData;
	_documentDownloaded;
	_documentUploading;
	_documentUploaded;
	_documentIsCheckedoutByOtherUser;
	_documentFileSelected;
	_documentReadonly;
	_documentCanBeDeleted;
	_metadataFieldsAssociationValues;
	_metadataValidationErrors;
	_digitalSignature;

	constructor(inputProps = {}) {
		const template = new Template({ id: inputProps.templateId });
		const gridData = new GridData(inputProps.gridFormParent);
		const document = new Document({});

		this.template = template;
		this.document = document;
		this.inputId = inputProps.id;
		this.inputName = inputProps.name;
		this.inputProps = inputProps;
		this.value = inputProps.value;
		this.selected = !this.document.isNew();
		this.selectedDuplicateDocument = null;
		this.duplicateDocuments = [];
		this.flashMessage = null;
		this.waitingForAction = false;
		this.documentLoaded = false;
		this.submitData = {};
		this.gridData = gridData;
		this.documentFileSelected = false;
		this.documentDownloaded = false;
		this.documentReadonly = false;
		this.documentUploading = false;
		this.documentUploaded = false;
		this.documentIsCheckedoutByOtherUser = false;
		this.documentCanBeDeleted = false;
		this.metadataFieldsAssociationValues = {};
		this.metadataValidationErrors = [];
		this.digitalSignature = {
			openModalSignature: false,
			localServiceAddress: 'http://127.0.0.1',
			baseContext: '/AssinadorDigitalLecom/',
			signerPingContext: '/AssinadorDigitalLecom/data/12',
			signerInvokeContext: '/AssinadorDigitalLecom/processar',
			signerCheckcompatibilityContext: '/AssinadorDigitalLecom/version?checkcompatibility=1.33',
			portsToTest: [8080, 7375, 8523, 10743, 37562, 50334, 60305],
			countIdPort: 0,
			noDigitalSign: false,
			waitingForTheSignedDocument: false,
			canceledDigitalSignature: false,
			signatureFailure: false,
			documentUploadedSignature: false,
			fileNameRowGrid: '',
			fileUUIDRowGrid: '',
			connectingDigitalSignService: true,
			notPermssionDigitalSign: true,
			buttonDownloadDigitalSignature: false,
			errorCompatibility: false,
			errorDigitalSignature: false
		};
	}

	get inputId() {
		return this._inputId;
	}

	set inputId(value) {
		this._inputId = value;
	}

	get inputName() {
		return this._inputName;
	}

	set inputName(value) {
		this._inputName = value;
	}

	get inputProps() {
		return this._inputProps;
	}

	set inputProps(value) {
		this._inputProps = value;
	}

	get template() {
		return this._template;
	}

	set template(value) {
		this._template = value;
	}

	get document() {
		return this._document;
	}

	set document(value) {
		this._document = value;
	}

	get selected() {
		return this._selected;
	}

	set selected(value) {
		this._selected = value;
	}

	get flashMessage() {
		return this._flashMessage;
	}

	set flashMessage(value) {
		this._flashMessage = value;
	}

	get duplicateDocuments() {
		return this._duplicateDocuments;
	}

	set duplicateDocuments(value) {
		this._duplicateDocuments = value;
	}

	get divergentDocumentVersion() {
		return this._divergentDocumentVersion;
	}

	set divergentDocumentVersion(value) {
		this._divergentDocumentVersion = value;
	}

	get selectedDuplicateDocument() {
		return this._selectedDuplicateDocument;
	}

	set selectedDuplicateDocument(value) {
		this._selectedDuplicateDocument = value;
	}

	get waitingForAction() {
		return this._waitingForAction;
	}

	set waitingForAction(value) {
		this._waitingForAction = value;
	}

	get documentUploading() {
		return this._documentUploading;
	}

	set documentUploading(value) {
		this._documentUploading = value;
	}

	get documentUploaded() {
		return this._documentUploaded;
	}

	set documentUploaded(value) {
		this._documentUploaded = value;
	}

	get documentLoaded() {
		return this._documentLoaded;
	}

	set documentLoaded(value) {
		this._documentLoaded = value;
	}

	get documentReadonly() {
		return this._documentReadonly;
	}

	set documentReadonly(value) {
		this._documentReadonly = value;
	}

	get documentCanBeDeleted() {
		return this._documentCanBeDeleted;
	}

	set documentCanBeDeleted(value) {
		this._documentCanBeDeleted = value;
	}

	get submitData() {
		return this._submitData;
	}

	set submitData(value) {
		this._submitData = value;
	}

	get gridData() {
		return this._gridData;
	}

	set gridData(value) {
		this._gridData = value;
	}

	get documentDownloaded() {
		return this._documentDownloaded;
	}

	set documentDownloaded(value) {
		this._documentDownloaded = value;
	}

	get documentIsCheckedoutByOtherUser() {
		return this._documentIsCheckedoutByOtherUser;
	}

	set documentIsCheckedoutByOtherUser(value) {
		this._documentIsCheckedoutByOtherUser = value;
	}

	get documentFileSelected() {
		return this._documentFileSelected;
	}

	set documentFileSelected(value) {
		this._documentFileSelected = value;
	}

	get value() {
		if (!!this.document.fileName && !!this.document.fileUUID)
			return `${this.document.fileName}:${this.document.fileUUID}`
	}

	set value(value) {
		if (!value) return;

		const { fileName, fileUUID } = DocumentHelper.parseDocumentValue(value);
		this.document.fileName = fileName;
		this.document.fileUUID = fileUUID;
	}

	get metadataFieldsAssociationValues() {
		return this._metadataFieldsAssociationValues;
	}

	set metadataFieldsAssociationValues(value) {
		this._metadataFieldsAssociationValues = value;
	}

	get metadataValidationErrors() {
		return this._metadataValidationErrors;
	}

	set metadataValidationErrors(value) {
		this._metadataValidationErrors = value;
	}

	get digitalSignature(){
		return this._digitalSignature;
	}

	set digitalSignature(value) {
		this._digitalSignature = value;
	}


}
